import React from 'react';
import '../css/components/error.css'

interface ErrorProps {
    children: React.ReactNode;
}

function Error(props: ErrorProps) {
    return (
        <div className="ss-error">{props.children}</div>
    );
}

export default Error;
